import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { insert, selectValues, update, validarCNPJ, validarCPF } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import powerAppsApi from '../../../services/powerapps';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';
import ModalFormAddPjOuPf from '../ModalFormAddPjOuPf/ModalFormAddPjOuPf';

const ModalFormAddFornecedor = ( props ) => {

  const [addFavModal, setAddFavModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [selPjs, setSelPjs] = useState([]);
  const [selPfs, setSelPfs] = useState([]);
  const [selectedFornecedor, setSelectedFornecedor ] = useState({})

  const handleClickOpenAddFavModal = () => setAddFavModal(true);
  const handleClickCloseAddFavModal = () => setAddFavModal(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    if (props.isPf) {
      const pfBody = {
        action: 'update',
        table: 'pf',
        data: {
          pf_id: selectedFornecedor.value,
          pf_fornecedor: 1
        }
      }

      const pfUpdated = await oikosApi.post('/', pfBody)

      props.setContrFornData({ ...props.contrFornData, contrForn_parteTab: 'pf', contrForn_parteId: selectedFornecedor.value });
      props.fetchPfsFornecedoresForSelect();

    } else {

      const pjBody = {
        action: 'update',
        table: 'pj',
        data: {
          pj_id: selectedFornecedor.value,
          pj_fornecedor: 1
        }
      }

      const pjUpdated = await oikosApi.post('/', pjBody)

      props.setContrFornData({ ...props.contrFornData, contrForn_parteTab: 'pj', contrForn_parteId: selectedFornecedor.value });
      props.fetchPjsFornecedoresForSelect();
    }

    props.getPossiveisFornecedores(props.isPf);

    setIsLoading(false);
  }

  const fetchPjsForSelect = async () => {
    const res = await selectValues('pj', 'pj_id', 'pj_nomefanta', {pj_ativo: 1}, {
      pj_emailPrin: "pj_emailPrin"
    });
    const sortedFornecedores = (res).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setSelPjs(sortedFornecedores);
  }

  const fetchPfsForSelect = async () => {
    const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1}, {
      pf_emailProf: "pf_emailProf"
    });
    const sortedFornecedores = (res).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setSelPfs(sortedFornecedores);
  }

  const getFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_nomefanta');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjs(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPfs(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  useEffect(() => {
    fetchPjsForSelect();
    fetchPfsForSelect();
  },[])

  return (
    <>
      <Btn
        size="sm"
        color="link"
        className="ml-2 px-0"
        onClick={(e)=>{
          e.preventDefault();
          handleClickOpenAddFavModal();
        }}
      >
        Adicionar fornecedor
      </Btn>
      {(props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Adicionar fornecedor
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <div className="d-flex">
                <Label>Pessoa Física</Label>
                <ModalFormAddPjOuPf
                  setSelPfsFornecedor={props.setSelPfsFornecedor}
                  setSelPjsFornecedor={props.setSelPjsFornecedor}
                  handleClickCloseAddFavModal={handleClickCloseAddFavModal}
                  contrFornData={props.contrFornData}
                  setContrFornData={props.setContrFornData}
                  getFornecedores={getFornecedores}
                  isPf={props.isPf}
                />
              </div>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selPfs}
                value={selectedFornecedor}
                onChange={(e) => {
                  setSelectedFornecedor(e)
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  if ((props.isPf && !selectedFornecedor.pf_emailProf) || (!props.isPf && !selectedFornecedor.pj_emailPrin)) {
                    return notifyError('Fornecedor sem email.')
                  }
                  await handleSubmit()
                  handleClickCloseAddFavModal();
                }
                }
              >
                Adicionar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
      {(!props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Adicionar fornecedor
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <div className="d-flex">
                <Label>Pessoa Jurídica</Label>
                <ModalFormAddPjOuPf
                  setSelPfsFornecedor={props.setSelPfsFornecedor}
                  setSelPjsFornecedor={props.setSelPjsFornecedor}
                  handleClickCloseAddFavModal={handleClickCloseAddFavModal}
                  contrFornData={props.contrFornData}
                  setContrFornData={props.setContrFornData}
                  getFornecedores={getFornecedores}
                  isPf={props.isPf}
                />
              </div>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selPjs}
                value={selectedFornecedor}
                onChange={(e) => {
                  setSelectedFornecedor(e)
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  await handleSubmit()
                  handleClickCloseAddFavModal();
                }
                }
              >
                Adicionar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
    </>
  )
}

export default ModalFormAddFornecedor;
